import React from 'react'; 
import { RadioButton } from '@progress/kendo-react-inputs';
 
const CusRadioG2Btn = (props) => {

    const{name, onChange, firstValue, secValue,label, checkedValue, disabled,labelDesp,firstValueLabel,secValueLabel} = props;
    const handleChange = React.useCallback(
        (e) => {
            props.onChange(e,name);
        },
        [onChange,checkedValue]
    )
    return (
        <div className="row around-xs inputPair elementVisible">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <div className="box">{label}</div>
            </div>
            <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <RadioButton id={name} name={name} value={firstValue} onChange={handleChange} checked={checkedValue === firstValue} disabled={disabled} >&nbsp;{firstValueLabel}</RadioButton>
                <br />
                <RadioButton id={name} name={name} value={secValue} onChange={handleChange} checked={checkedValue === secValue} disabled={disabled} >&nbsp;{secValueLabel}</RadioButton>
            </div> 
        </div>  
    )
}

export default CusRadioG2Btn;